import { useParams } from 'react-router-dom'

import { Link, Stack, Text } from '..'
import grantIcon from '../../static/logo/grant-icon.svg'
import documentIcon from '../../static/logo/document-icon.svg'
import contributeIcon from '../../static/logo/contribute-icon.svg'

export function Quicklinks() {
  const { fundId } = useParams()
  const quickLinks = [
    { to: `/funds/${fundId}/contribute`, icon: contributeIcon, alt: '', label: 'Contribute' },
    { to: `/funds/${fundId}/grant`, icon: grantIcon, alt: '', label: 'Gift' },
    { to: `/funds/${fundId}/documents`, icon: documentIcon, alt: '', label: 'Documents' },
  ]
  if (!fundId) return null
  return (
    <Stack direction="row" justifyContent="space-evenly">
      {quickLinks.map(({ to, icon, label, alt }) => (
        <Link key={to} to={to}>
          <Stack spacing={1} justifyContent="center" alignItems="center">
            <img src={icon} alt={alt} width="35" height="35" />
            <Text.AltBody>{label}</Text.AltBody>
          </Stack>
        </Link>
      ))}
    </Stack>
  )
}
